import { styled } from "@mui/material";
import { useRef, useState } from "react";
import { PhotoCamera } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";

const Input = styled("input")({
  display: "none",
});

export const CameraButton = ({
  handleImageInput,
  disabled = false,
}: {
  handleImageInput: (file: UploadImage) => Promise<void>;
  disabled?: boolean;
}) => {
  const [loading, setLoading] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleInputEvent = async (event: React.FormEvent<HTMLInputElement>) => {
    const inputFiles = event.currentTarget.files;

    if (inputFiles == null || inputFiles.length === 0) return;

    setLoading(true);

    const inputFile = inputFiles[0];

    const { name, type } = inputFile;
    const reader = new FileReader();
    reader.onerror = (error) => console.log(error);
    reader.onload = (evt) => {
      const result = evt.target?.result;
      if (result && typeof result === "string") {
        handleImageInput({ inputFile, data: result, filename: name, "mime-type": type }).finally(() => {
          setLoading(false);
        });
      } else setLoading(false);
    };
    reader.readAsDataURL(inputFile);
  };

  return (
    <label htmlFor="icon-button-file" className="custom-file-upload">
      <Input
        accept="image/*;capture=camera"
        type="file"
        ref={inputRef}
        id="icon-button-file"
        onInput={(event) => {
          handleInputEvent(event);
        }}
      />
      <LoadingButton
        variant="outlined"
        startIcon={<PhotoCamera />}
        fullWidth
        disabled={disabled}
        color="primary"
        aria-label="upload picture"
        onClick={() => inputRef.current?.click()}
        loading={loading}
      >
        ta bild
      </LoadingButton>
    </label>
  );
};
